import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";
import ExcelToJsonViewer from "../components/ExcelToJsonViewer";

const ExcelToJsonTool = () => {
  return (
    <>
      <Helmet>
        <title>Excel to JSON & Table Viewer - Free Online Converter</title>
        <meta
          name="description"
          content="Convert Excel (.xlsx, .xls, .csv) to JSON and view as table online. Easy drag & drop tool with download & remove options. No API or backend required."
        />
        <meta
          name="keywords"
          content="excel to json, excel table viewer, xlsx to json, csv to json, online excel converter, frontend excel viewer"
        />
        <link rel="canonical" href="https://freelity.com/excel-to-json" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2 className="mb-4">Excel to JSON & Table Viewer</h2>
          <ExcelToJsonViewer />
        </div>
      </section>
    </>
  );
};

export default ExcelToJsonTool;
